import APIS from "../../constant/EndPoint";
import ComboboxInput from "../Reusable/ComboboxInput";
import TextField from "../Reusable/TextField";
//@ts-ignore
import { tw } from "@careinfo/tailwind";

const CityForm = ({
  register,
  errors,
  setValue,
  getValues,
  clearErrors,
}: any) => {
  return (
    <div className={tw`grid sm:grid-cols-1 md:grid-cols-2 gap-x-4 mx-4`}>
      <ComboboxInput
        url={APIS.LOCATION_LIST}
        props={{ level: 0, is_active: true }}
        queryKey={"country"}
        register={register("country")}
        errors={errors?.country}
        name={"country"}
        label={"Country"}
        setValue={setValue}
        placeholder={"Search Country"}
        getValues={getValues}
        clearErrors={clearErrors}
      />
      <ComboboxInput
        url={APIS.LOCATION_LIST}
        props={{ level: 1, is_active: true, parent: getValues("country") }}
        queryKey={`state-${getValues("country")}`}
        register={register("state")}
        errors={errors?.state}
        name={"state"}
        label={"State"}
        setValue={setValue}
        placeholder={"Search State"}
        getValues={getValues}
        clearErrors={clearErrors}
      />
      <ComboboxInput
        url={APIS.LOCATION_LIST}
        props={{ level: 2, is_active: true, parent: getValues("state") }}
        queryKey={`district-${getValues("state")}`}
        register={register("parent")}
        errors={errors?.parent}
        name={"parent"}
        label={"District"}
        setValue={setValue}
        placeholder={"Search District"}
        getValues={getValues}
        clearErrors={clearErrors}
      />
      <TextField
        label={"Name"}
        register={register("name")}
        errors={errors?.name}
      />
      <TextField
        label={"Code"}
        register={register("code")}
        errors={errors?.code}
      />
      <TextField
        label={"Covered Area"}
        register={register("covered_area")}
        errors={errors?.covered_area}
      />
    </div>
  );
};

export default CityForm;
